/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export type Orientation = 'stacked' | 'side-by-side';

export class Orientations {
  static readonly STACKED: Orientation = 'stacked';
  static readonly SIDE_BY_SIDE: Orientation = 'side-by-side';
}
